<script setup>
import {
	UserCircleIcon,
	MenuIcon,
	XIcon,
} from '@heroicons/vue/outline'

import NavMenu from '@/Layout/NavMenu.vue'
import { ref } from 'vue'

import { useAuthStore } from '@/Stores/auth'
const auth = useAuthStore()

const showMenu = ref(false)
</script>

<template>
	<div class="relative z-10 flex items-center grow justify-end md:hidden">
		<!-- Mobile menu button -->
		<Button
			class="rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-gray-900"
			@click="showMenu = !showMenu"
		>
			<span class="sr-only">Open menu</span>
			<MenuIcon v-if="!showMenu" class="block h-6 w-6" aria-hidden="true" />
			<XIcon v-else class="block h-6 w-6" aria-hidden="true" />
		</Button>
	</div>
	<transition 
		enter-active-class="transition ease-out duration-100" 
		enter-from-class="transform opacity-0 scale-95" 
		enter-to-class="transform opacity-100 scale-100" 
		leave-active-class="transition ease-in duration-75" 
		leave-from-class="transform opacity-100 scale-100" 
		leave-to-class="transform opacity-0 scale-95"
		v-if="showMenu"
		class="absolute rounded-md w-full top-[75px] right-0 bg-white shadow-lg z-10 md:hidden"
	>
		<NavMenu @click="showMenu = !showMenu" />
	</transition>
	<div class="hidden md:relative md:z-10 md:ml-4 md:flex md:items-center">

		<!-- Profile dropdown -->
		<div class="flex-shrink-0 relative ml-4">
			<div>
				<div class="bg-white rounded-full flex items-center text-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-900">
					<span class="text-sm mr-2">{{ auth.user?.email }}</span>
					<UserCircleIcon class="h-8 w-8 rounded-full" />
				</div>
			</div>
			<transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
				
			</transition>
		</div>
	</div>
</template>
